// extracted by mini-css-extract-plugin
export default {"card":"style_card__pIKVL","cardInput":"style_cardInput__lP8Xu","cardView":"style_cardView__byw8t","delete":"style_delete__lMb2r","controls":"style_controls__tJ5Zn"};